module.exports = __webpack_public_path__ + "img/talmud_item.6cb8edb8.6cb8edb8.png";